
export default {
    AWS_LAMBDA_GETSIGNEDURL_UPLOAD_ENDPOINT: 'https://qezl0w6hm7.execute-api.us-west-2.amazonaws.com/stage/upload',
    AWS_LAMBDA_GETSIGNEDURL_DOWNLOAD_ENDPOINT: 'https://284wd52xva.execute-api.us-west-2.amazonaws.com/stage/download',
    AWS_LAMBDA_GET_LIST_OF_FILES_ENDPOINT: 'https://hy1cmm1a1j.execute-api.us-west-2.amazonaws.com/stage/get-list-of-files?id=',
    AWS_LAMBDA_GENERATE_SERVER_ENDPOINT: 'https://a4q10mv6k8.execute-api.us-west-2.amazonaws.com/stage/generate-server',
    AWS_LAMBDA_GET_SERVER_EXPIRATION: 'https://o85io8bypf.execute-api.us-west-2.amazonaws.com/stage/get-server-expiration'
  }


// WEBPACK FOOTER //
// ./src/config.js